import { useLayoutEffect } from "react";
import { acquireLoader } from "../LoaderRenderer/loaderStore";

/**
 * Activator for the singleton LoaderRenderer host (mounted in App).
 * The visible loader lives in one persistent DOM node, so remounts of
 * this component across loading gates never restart the animation.
 * Accepts (and ignores) legacy props like `style` so existing call
 * sites are unaffected.
 */
// eslint-disable-next-line no-unused-vars
const LoadingPage = (props) => {
  useLayoutEffect(acquireLoader, []);

  return null;
};

export default LoadingPage;
